export enum HoldingType {
  TopTenHoldings = 'top 10 holdings',
  HoldingsOnThresholdOrAbove = 'holdings of 0.7% and above',
}

export default HoldingType;
